/* istanbul ignore file */
import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import type { BreadcrumbItemProps } from '../BreadcrumbsTypes';

const ActivitiesAndNotesBreadcrumbItem = (props: Partial<BreadcrumbItemProps>) => {
  return <BreadcrumbItem {...props}>Activities & Notes</BreadcrumbItem>;
};

export default ActivitiesAndNotesBreadcrumbItem;
